import { AuthPage } from "@refinedev/antd";

const authCredentials = {
  email: "demo@demo.com",
  password: "demodemo",
};

export const ForgotPasswordPage = () => {
  return (<AuthPage
    type="forgotPassword"
    formProps={{
      initialValues: {
        ...authCredentials,
      },
    }}
    renderContent={(content, title) => {
      return content;
    }}
  />);
};